module.exports = __webpack_public_path__ + "static/media/favicon.9330d9c5.png";